export const IconDropdownArrowSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="7" height="5">
  <style>
    .onDarkBackground{opacity:0.5}
    .onDarkBackground.active,.onDarkBackground.hover{opacity:1}
    .disabled{opacity:0.35!important}
    .active path,.hover path{fill:#333}
    path,.disabled path{fill:#666}
    .onDarkBackground path{fill:#fff!important}
  </style>
  <path d="M5.8,1H1.2C1.1,1,1,1.1,1.1,1.2l2.3,2.7C3.4,4,3.6,4,3.6,3.9l2.3-2.7 C6,1.1,5.9,1,5.8,1z"/>
</svg>`;
